import "./Dashboard.css";
import moment from "moment";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea, Box } from "@mui/material";
import { Link } from "react-router-dom";

import "@fontsource/roboto/400.css";

import "@fontsource/roboto/700.css";

const Dashboard = (props) => {
  Date.getFormattedDateDiff = function (date1, date2) {
    let b = moment(date1),
      a = moment(date2),
      intervals = [
        "years",
        "months",
        "weeks",
        "days",
        "hours",
        "minutes",
        "seconds",
      ],
      out = [];

    for (var i = 0; i < intervals.length; i++) {
      var diff = a.diff(b, intervals[i]);
      b.add(diff, intervals[i]);
      if (diff !== 0) {
        out.push(diff + " " + intervals[i] + " ago");
        break;
      }
    }
    if (out === []) {
      out.push("just now");
    }
    return out;
  };

  let today = new Date(),
    releaseDate = new Date(props.data.releaseDate);
  props.data.date = Date.getFormattedDateDiff(releaseDate, today);
  const linked = {
    pathname: "/" + props.data._id,
    state: {
      date: props.data.date,
      data: props.data,
    },
  };

  return (
    <Link
      className="video-tile-link"
      to={linked}
      style={{ textDecoration: "none" }}
      key={props.data._id}
    >
      <Box
        className="video-tile"
        display="flex"
        flexDirection="column"
        sx={{ maxWidth: 276, maxHeight: 241 }}
      >
        <img
          src={props.data.previewImage}
          height="153"
          alt="thumbnail"
          class="video-img"
        />
        <Box marginTop="0.4rem">
          <Typography
            gutterBottom
            variant="body1"
            component="div"
            className="title-card"
          >
            {props.data.title}
          </Typography>
          <Typography
            gutterBottom
            variant="subtitle2"
            sx={{ opacity: "0.4" }}
            className="dateName"
          >
            {props.data.date}
          </Typography>
        </Box>
      </Box>
    </Link>
  );
};

export default Dashboard;
